import { TailWhitespaceCalculation } from '@tencent/alloy-editor';

export const FONT_SCALE = 2;

// 默认原始文字大小
export const DEFAULT_RAW_FONTSIZE = 18;

// 项目符号继承过滤属性
export const CHARACTER_INHERIT_FILTER_KEYS = [
    'character', 'buNone', 'buFont', 'character_bullet_char', 'buAutoNum', 'buBlip', 'buClrTx', 'buFontTx', 'buSzTx',
];

export const CHARACTER_INHERIT_INCLUDE_KEYS = ['buClr', 'buSzPct', 'buSzPts'];

// 项目编号收拢到props.paragraphProps.character
export const CHARACTER_KEYS = CHARACTER_INHERIT_FILTER_KEYS.concat(CHARACTER_INHERIT_INCLUDE_KEYS);

/* eslint-disable import/prefer-default-export */
export const BU_TYPE = {
    INHERIT: 'inhert',
    NONE: 'none',
    BULLET_CHAR: 'bulletChar',
    AUTO_NUM: 'autoNum',
    BLIP: 'blip',
    CUSTOM: 'custom',
} as const;

export type BuTypeValue = typeof BU_TYPE[keyof typeof BU_TYPE];

// 在 textRun styles 中对应的 key
export const TEXT_STROKE_KEY = 'border';
// 在 textRun styles 中对应的 key
export const TEXT_EFFECT_KEY = 'effect';
export const TEXT_FILL_LIST = ['gradFill', 'image', 'pattFill', 'noFill'];
export const TEXT_COLOR_FILL = 'color';
export const ALL_TEXT_FILL = TEXT_FILL_LIST.concat(TEXT_COLOR_FILL);

// src/framework/canvas-mode/canvas-render/components/text-editor/utils/editor-constants.ts
export const DEFAULT_FONTSIZE = 18 * FONT_SCALE;
/**
 * 查找替换功能，文本默认背景色
 */
export const SEARCH_COLOR = 'rgba(242, 226, 0, 0.5)';
export const HIGHLIGHT_COLOR = 'rgba(241, 185, 0, 1)';


// Editor默认padding ， 1倍值
export const DEFAULT_PADDING_TB = 3.685;  // 0.13厘米
export const DEFAULT_PADDING_LR = 7;     // 0.25厘米

// 图表文本框默认padding ， 1倍值
export const CHART_DEFAULT_PADDING_T = 2.53;  // 0.1厘米
export const CHART_DEFAULT_PADDING_B = 2.28;  // 0.07厘米
export const CHART_DEFAULT_PADDING_LR = 3.08;  // 0.11厘米

// 默认tab size
export const DEFAULT_TAB_SIZE = 72;   // 2.54厘米

export const PARAGRAPH_STYLE_KEY = [
    'PPTLineHeight',
    'buNone',
    'buFont',
    'character',
    'character_bullet_char',
    'buBlip',
    'buClr',
    'buSzPct',
    'buAutoNum',
    'lineHeight',
    'lineHeightIs',
    'marginLeft',
    'tabSize',
    'textAlign',
    'textIndent',
    'level',
    'tabList',
    'paddingTop',
    'paddingTopIs',
    'paddingBottom',
    'paddingBottomIs',
];

// 文字上下标属性在 model 中的 key
export const TEXT_BASELINE_OFFSET = 'baselineOffset';

// 文字下标的默认偏移量
export const SUBSCRIPT_DEFAULT_BASELINE_OFFSET = -0.25;

export const SUBSCRIPT_KEY = 'subscript';

// 文字上标的默认偏移量
export const SUPERSCRIPT_DEFAULT_BASELINE_OFFSET = 0.3;

export const SUPERSCRIPT_KEY = 'superscript';

// 文字上的效果key（model的paragraphList中的属性是effect，但应用到菜单等处，为了和形状的关键字区分开，所以改为font-effect）
export const FONT_EFFECT_KEY = 'font-effect';

export const FONT_FILL_KEY = 'font-fill';

export const FONT_BORDER_KEY = 'font-border';

// slide 中常规文本（形状、表格、备注等）默认的 尾部空格宽度计算方式
export const DEFAULT_TAIL_WHITESPACE_CALCULATION = TailWhitespaceCalculation.Auto;
